import { getGoogleSheetsClientId } from './google-sheets-client-id';
import { openOAuthPopup, type OAuthOpenResponse } from './oauth-popup';

export const REQUIRED_GOOGLE_SHEETS_SCOPE = 'https://www.googleapis.com/auth/drive.file';

const GOOGLE_AUTHORIZATION_URL = 'https://accounts.google.com/o/oauth2/v2/auth';
const USERINFO_EMAIL_SCOPE = 'https://www.googleapis.com/auth/userinfo.email';

type OpenGoogleSheetsOptions = {
  additionalGrant?: boolean;
};

export function openGoogleSheetsPopup({
  additionalGrant = false,
}: OpenGoogleSheetsOptions = {}): Promise<OAuthOpenResponse> {
  return openOAuthPopup({
    provider: 'google-sheets',
    baseUrl: GOOGLE_AUTHORIZATION_URL,
    clientId: getGoogleSheetsClientId(),
    scope: additionalGrant ? REQUIRED_GOOGLE_SHEETS_SCOPE : `${REQUIRED_GOOGLE_SHEETS_SCOPE} ${USERINFO_EMAIL_SCOPE}`,
    extraParams: {
      access_type: 'offline',
      include_granted_scopes: true,
      prompt: 'consent',
    },
  });
}

export async function accessTokenHasRequiredGoogleSheetsScope(accessToken: string): Promise<boolean> {
  const response = await fetch(
    `https://www.googleapis.com/oauth2/v1/tokeninfo?access_token=${encodeURIComponent(accessToken)}`,
  );
  if (!response.ok) {
    throw new Error(`Google token scope request failed with status ${response.status}`);
  }
  // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
  const data = (await response.json()) as { scope?: string };

  return data.scope?.split(' ').includes(REQUIRED_GOOGLE_SHEETS_SCOPE) === true;
}
